// source: tournament.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.dowtex.tournaments.AdvanceRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.CreateRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.Entrant', null, global);
goog.exportSymbol('proto.dowtex.tournaments.EntrantInput', null, global);
goog.exportSymbol('proto.dowtex.tournaments.EntrantMemberInput', null, global);
goog.exportSymbol('proto.dowtex.tournaments.EntrantRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.GetRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.JoinRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.ListRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.Match', null, global);
goog.exportSymbol('proto.dowtex.tournaments.MatchStatus', null, global);
goog.exportSymbol('proto.dowtex.tournaments.Permissions', null, global);
goog.exportSymbol('proto.dowtex.tournaments.ReportResultRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.ShareTokenRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.Stage', null, global);
goog.exportSymbol('proto.dowtex.tournaments.Standing', null, global);
goog.exportSymbol('proto.dowtex.tournaments.TournamentStatus', null, global);
goog.exportSymbol('proto.dowtex.tournaments.TournamentSummaries', null, global);
goog.exportSymbol('proto.dowtex.tournaments.TournamentSummary', null, global);
goog.exportSymbol('proto.dowtex.tournaments.TournamentView', null, global);
goog.exportSymbol('proto.dowtex.tournaments.UpdateSettingsRequest', null, global);
goog.exportSymbol('proto.dowtex.tournaments.Visibility', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.EntrantInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dowtex.tournaments.EntrantInput.repeatedFields_, null);
};
goog.inherits(proto.dowtex.tournaments.EntrantInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.EntrantInput.displayName = 'proto.dowtex.tournaments.EntrantInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.EntrantMemberInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.EntrantMemberInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.EntrantMemberInput.displayName = 'proto.dowtex.tournaments.EntrantMemberInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.CreateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dowtex.tournaments.CreateRequest.repeatedFields_, null);
};
goog.inherits(proto.dowtex.tournaments.CreateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.CreateRequest.displayName = 'proto.dowtex.tournaments.CreateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.GetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.GetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.GetRequest.displayName = 'proto.dowtex.tournaments.GetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.ListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.ListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.ListRequest.displayName = 'proto.dowtex.tournaments.ListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.UpdateSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.UpdateSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.UpdateSettingsRequest.displayName = 'proto.dowtex.tournaments.UpdateSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.ReportResultRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.ReportResultRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.ReportResultRequest.displayName = 'proto.dowtex.tournaments.ReportResultRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.EntrantRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.EntrantRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.EntrantRequest.displayName = 'proto.dowtex.tournaments.EntrantRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.AdvanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.AdvanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.AdvanceRequest.displayName = 'proto.dowtex.tournaments.AdvanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.ShareTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.ShareTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.ShareTokenRequest.displayName = 'proto.dowtex.tournaments.ShareTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.JoinRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.JoinRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.JoinRequest.displayName = 'proto.dowtex.tournaments.JoinRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.TournamentSummaries = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dowtex.tournaments.TournamentSummaries.repeatedFields_, null);
};
goog.inherits(proto.dowtex.tournaments.TournamentSummaries, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.TournamentSummaries.displayName = 'proto.dowtex.tournaments.TournamentSummaries';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.TournamentSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.TournamentSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.TournamentSummary.displayName = 'proto.dowtex.tournaments.TournamentSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.TournamentView = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dowtex.tournaments.TournamentView.repeatedFields_, null);
};
goog.inherits(proto.dowtex.tournaments.TournamentView, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.TournamentView.displayName = 'proto.dowtex.tournaments.TournamentView';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.Entrant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.Entrant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.Entrant.displayName = 'proto.dowtex.tournaments.Entrant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.Stage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.Stage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.Stage.displayName = 'proto.dowtex.tournaments.Stage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.Standing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.Standing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.Standing.displayName = 'proto.dowtex.tournaments.Standing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.Match = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dowtex.tournaments.Match, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.Match.displayName = 'proto.dowtex.tournaments.Match';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dowtex.tournaments.Permissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dowtex.tournaments.Permissions.repeatedFields_, null);
};
goog.inherits(proto.dowtex.tournaments.Permissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dowtex.tournaments.Permissions.displayName = 'proto.dowtex.tournaments.Permissions';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dowtex.tournaments.EntrantInput.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.EntrantInput.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.EntrantInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.EntrantInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.EntrantInput.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
seed: jspb.Message.getFieldWithDefault(msg, 2, 0),
membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.dowtex.tournaments.EntrantMemberInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.EntrantInput}
 */
proto.dowtex.tournaments.EntrantInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.EntrantInput;
  return proto.dowtex.tournaments.EntrantInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.EntrantInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.EntrantInput}
 */
proto.dowtex.tournaments.EntrantInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeed(value);
      break;
    case 3:
      var value = new proto.dowtex.tournaments.EntrantMemberInput;
      reader.readMessage(value,proto.dowtex.tournaments.EntrantMemberInput.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.EntrantInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.EntrantInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.EntrantInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.EntrantInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSeed();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.dowtex.tournaments.EntrantMemberInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.dowtex.tournaments.EntrantInput.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.EntrantInput} returns this
 */
proto.dowtex.tournaments.EntrantInput.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 seed = 2;
 * @return {number}
 */
proto.dowtex.tournaments.EntrantInput.prototype.getSeed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.EntrantInput} returns this
 */
proto.dowtex.tournaments.EntrantInput.prototype.setSeed = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated EntrantMemberInput members = 3;
 * @return {!Array<!proto.dowtex.tournaments.EntrantMemberInput>}
 */
proto.dowtex.tournaments.EntrantInput.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.dowtex.tournaments.EntrantMemberInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dowtex.tournaments.EntrantMemberInput, 3));
};


/**
 * @param {!Array<!proto.dowtex.tournaments.EntrantMemberInput>} value
 * @return {!proto.dowtex.tournaments.EntrantInput} returns this
*/
proto.dowtex.tournaments.EntrantInput.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.dowtex.tournaments.EntrantMemberInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.EntrantMemberInput}
 */
proto.dowtex.tournaments.EntrantInput.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.dowtex.tournaments.EntrantMemberInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.EntrantInput} returns this
 */
proto.dowtex.tournaments.EntrantInput.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.EntrantMemberInput.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.EntrantMemberInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.EntrantMemberInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.EntrantMemberInput.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.EntrantMemberInput}
 */
proto.dowtex.tournaments.EntrantMemberInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.EntrantMemberInput;
  return proto.dowtex.tournaments.EntrantMemberInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.EntrantMemberInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.EntrantMemberInput}
 */
proto.dowtex.tournaments.EntrantMemberInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.EntrantMemberInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.EntrantMemberInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.EntrantMemberInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.EntrantMemberInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.dowtex.tournaments.EntrantMemberInput.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.EntrantMemberInput} returns this
 */
proto.dowtex.tournaments.EntrantMemberInput.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.dowtex.tournaments.EntrantMemberInput.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.EntrantMemberInput} returns this
 */
proto.dowtex.tournaments.EntrantMemberInput.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dowtex.tournaments.CreateRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.CreateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.CreateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.CreateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.CreateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
discipline: jspb.Message.getFieldWithDefault(msg, 3, ""),
app: jspb.Message.getFieldWithDefault(msg, 4, ""),
contextId: jspb.Message.getFieldWithDefault(msg, 5, 0),
format: jspb.Message.getFieldWithDefault(msg, 6, ""),
entrantsList: jspb.Message.toObjectList(msg.getEntrantsList(),
    proto.dowtex.tournaments.EntrantInput.toObject, includeInstance),
settingsJson: jspb.Message.getFieldWithDefault(msg, 8, ""),
visibility: jspb.Message.getFieldWithDefault(msg, 9, 0),
password: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.CreateRequest}
 */
proto.dowtex.tournaments.CreateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.CreateRequest;
  return proto.dowtex.tournaments.CreateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.CreateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.CreateRequest}
 */
proto.dowtex.tournaments.CreateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscipline(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContextId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormat(value);
      break;
    case 7:
      var value = new proto.dowtex.tournaments.EntrantInput;
      reader.readMessage(value,proto.dowtex.tournaments.EntrantInput.deserializeBinaryFromReader);
      msg.addEntrants(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettingsJson(value);
      break;
    case 9:
      var value = /** @type {!proto.dowtex.tournaments.Visibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.CreateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.CreateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.CreateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.CreateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDiscipline();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContextId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getFormat();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEntrantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.dowtex.tournaments.EntrantInput.serializeBinaryToWriter
    );
  }
  f = message.getSettingsJson();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string discipline = 3;
 * @return {string}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getDiscipline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setDiscipline = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string app = 4;
 * @return {string}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 context_id = 5;
 * @return {number}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getContextId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setContextId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string format = 6;
 * @return {string}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated EntrantInput entrants = 7;
 * @return {!Array<!proto.dowtex.tournaments.EntrantInput>}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getEntrantsList = function() {
  return /** @type{!Array<!proto.dowtex.tournaments.EntrantInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dowtex.tournaments.EntrantInput, 7));
};


/**
 * @param {!Array<!proto.dowtex.tournaments.EntrantInput>} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
*/
proto.dowtex.tournaments.CreateRequest.prototype.setEntrantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.dowtex.tournaments.EntrantInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.EntrantInput}
 */
proto.dowtex.tournaments.CreateRequest.prototype.addEntrants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.dowtex.tournaments.EntrantInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.clearEntrantsList = function() {
  return this.setEntrantsList([]);
};


/**
 * optional string settings_json = 8;
 * @return {string}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getSettingsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setSettingsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Visibility visibility = 9;
 * @return {!proto.dowtex.tournaments.Visibility}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getVisibility = function() {
  return /** @type {!proto.dowtex.tournaments.Visibility} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.dowtex.tournaments.Visibility} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string password = 10;
 * @return {string}
 */
proto.dowtex.tournaments.CreateRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.CreateRequest} returns this
 */
proto.dowtex.tournaments.CreateRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.GetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.GetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.GetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.GetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
token: jspb.Message.getFieldWithDefault(msg, 2, ""),
shareToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
password: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.GetRequest}
 */
proto.dowtex.tournaments.GetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.GetRequest;
  return proto.dowtex.tournaments.GetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.GetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.GetRequest}
 */
proto.dowtex.tournaments.GetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.GetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.GetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.GetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.GetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getShareToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.dowtex.tournaments.GetRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.GetRequest} returns this
 */
proto.dowtex.tournaments.GetRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string token = 2;
 * @return {string}
 */
proto.dowtex.tournaments.GetRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.GetRequest} returns this
 */
proto.dowtex.tournaments.GetRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string share_token = 3;
 * @return {string}
 */
proto.dowtex.tournaments.GetRequest.prototype.getShareToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.GetRequest} returns this
 */
proto.dowtex.tournaments.GetRequest.prototype.setShareToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.dowtex.tournaments.GetRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.GetRequest} returns this
 */
proto.dowtex.tournaments.GetRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.ListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.ListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.ListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.ListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
mine: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
app: jspb.Message.getFieldWithDefault(msg, 3, ""),
contextId: jspb.Message.getFieldWithDefault(msg, 4, 0),
publicOnly: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.ListRequest}
 */
proto.dowtex.tournaments.ListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.ListRequest;
  return proto.dowtex.tournaments.ListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.ListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.ListRequest}
 */
proto.dowtex.tournaments.ListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMine(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContextId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPublicOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.ListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.ListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.ListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.ListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMine();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContextId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPublicOnly();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.ListRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.ListRequest} returns this
 */
proto.dowtex.tournaments.ListRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool mine = 2;
 * @return {boolean}
 */
proto.dowtex.tournaments.ListRequest.prototype.getMine = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.ListRequest} returns this
 */
proto.dowtex.tournaments.ListRequest.prototype.setMine = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string app = 3;
 * @return {string}
 */
proto.dowtex.tournaments.ListRequest.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.ListRequest} returns this
 */
proto.dowtex.tournaments.ListRequest.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 context_id = 4;
 * @return {number}
 */
proto.dowtex.tournaments.ListRequest.prototype.getContextId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ListRequest} returns this
 */
proto.dowtex.tournaments.ListRequest.prototype.setContextId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool public_only = 5;
 * @return {boolean}
 */
proto.dowtex.tournaments.ListRequest.prototype.getPublicOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.ListRequest} returns this
 */
proto.dowtex.tournaments.ListRequest.prototype.setPublicOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.UpdateSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.UpdateSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.UpdateSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 3, 0),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
settingsJson: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.UpdateSettingsRequest}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.UpdateSettingsRequest;
  return proto.dowtex.tournaments.UpdateSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.UpdateSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.UpdateSettingsRequest}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedVersion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettingsJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.UpdateSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.UpdateSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.UpdateSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSettingsJson();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.UpdateSettingsRequest} returns this
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.UpdateSettingsRequest} returns this
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 expected_version = 3;
 * @return {number}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.UpdateSettingsRequest} returns this
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.UpdateSettingsRequest} returns this
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string settings_json = 5;
 * @return {string}
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.getSettingsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.UpdateSettingsRequest} returns this
 */
proto.dowtex.tournaments.UpdateSettingsRequest.prototype.setSettingsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.ReportResultRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.ReportResultRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.ReportResultRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
matchId: jspb.Message.getFieldWithDefault(msg, 3, 0),
winnerId: jspb.Message.getFieldWithDefault(msg, 4, 0),
scoreA: jspb.Message.getFieldWithDefault(msg, 5, 0),
scoreB: jspb.Message.getFieldWithDefault(msg, 6, 0),
hasScore: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.ReportResultRequest}
 */
proto.dowtex.tournaments.ReportResultRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.ReportResultRequest;
  return proto.dowtex.tournaments.ReportResultRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.ReportResultRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.ReportResultRequest}
 */
proto.dowtex.tournaments.ReportResultRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMatchId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWinnerId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScoreA(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScoreB(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasScore(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.ReportResultRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.ReportResultRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.ReportResultRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMatchId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getWinnerId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getScoreA();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getScoreB();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getHasScore();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 match_id = 3;
 * @return {number}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getMatchId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setMatchId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 winner_id = 4;
 * @return {number}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getWinnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setWinnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 score_a = 5;
 * @return {number}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getScoreA = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setScoreA = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 score_b = 6;
 * @return {number}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getScoreB = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setScoreB = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool has_score = 7;
 * @return {boolean}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getHasScore = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setHasScore = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int32 expected_version = 8;
 * @return {number}
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ReportResultRequest} returns this
 */
proto.dowtex.tournaments.ReportResultRequest.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.EntrantRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.EntrantRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.EntrantRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.EntrantRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
entrantId: jspb.Message.getFieldWithDefault(msg, 3, 0),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.EntrantRequest}
 */
proto.dowtex.tournaments.EntrantRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.EntrantRequest;
  return proto.dowtex.tournaments.EntrantRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.EntrantRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.EntrantRequest}
 */
proto.dowtex.tournaments.EntrantRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEntrantId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.EntrantRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.EntrantRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.EntrantRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.EntrantRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getEntrantId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.EntrantRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.EntrantRequest} returns this
 */
proto.dowtex.tournaments.EntrantRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.dowtex.tournaments.EntrantRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.EntrantRequest} returns this
 */
proto.dowtex.tournaments.EntrantRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 entrant_id = 3;
 * @return {number}
 */
proto.dowtex.tournaments.EntrantRequest.prototype.getEntrantId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.EntrantRequest} returns this
 */
proto.dowtex.tournaments.EntrantRequest.prototype.setEntrantId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 expected_version = 4;
 * @return {number}
 */
proto.dowtex.tournaments.EntrantRequest.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.EntrantRequest} returns this
 */
proto.dowtex.tournaments.EntrantRequest.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.AdvanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.AdvanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.AdvanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.AdvanceRequest}
 */
proto.dowtex.tournaments.AdvanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.AdvanceRequest;
  return proto.dowtex.tournaments.AdvanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.AdvanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.AdvanceRequest}
 */
proto.dowtex.tournaments.AdvanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.AdvanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.AdvanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.AdvanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.AdvanceRequest} returns this
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.AdvanceRequest} returns this
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 expected_version = 3;
 * @return {number}
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.AdvanceRequest} returns this
 */
proto.dowtex.tournaments.AdvanceRequest.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.ShareTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.ShareTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.ShareTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 3, 0),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.ShareTokenRequest}
 */
proto.dowtex.tournaments.ShareTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.ShareTokenRequest;
  return proto.dowtex.tournaments.ShareTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.ShareTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.ShareTokenRequest}
 */
proto.dowtex.tournaments.ShareTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpectedVersion(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.ShareTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.ShareTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.ShareTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.ShareTokenRequest} returns this
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ShareTokenRequest} returns this
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 expected_version = 3;
 * @return {number}
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.ShareTokenRequest} returns this
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool enabled = 4;
 * @return {boolean}
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.ShareTokenRequest} returns this
 */
proto.dowtex.tournaments.ShareTokenRequest.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.JoinRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.JoinRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.JoinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.JoinRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, 0),
password: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.JoinRequest}
 */
proto.dowtex.tournaments.JoinRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.JoinRequest;
  return proto.dowtex.tournaments.JoinRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.JoinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.JoinRequest}
 */
proto.dowtex.tournaments.JoinRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.JoinRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.JoinRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.JoinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.JoinRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.dowtex.tournaments.JoinRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.JoinRequest} returns this
 */
proto.dowtex.tournaments.JoinRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 id = 2;
 * @return {number}
 */
proto.dowtex.tournaments.JoinRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.JoinRequest} returns this
 */
proto.dowtex.tournaments.JoinRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.dowtex.tournaments.JoinRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.JoinRequest} returns this
 */
proto.dowtex.tournaments.JoinRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dowtex.tournaments.TournamentSummaries.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.TournamentSummaries.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.TournamentSummaries.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.TournamentSummaries} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.TournamentSummaries.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentsList: jspb.Message.toObjectList(msg.getTournamentsList(),
    proto.dowtex.tournaments.TournamentSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.TournamentSummaries}
 */
proto.dowtex.tournaments.TournamentSummaries.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.TournamentSummaries;
  return proto.dowtex.tournaments.TournamentSummaries.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.TournamentSummaries} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.TournamentSummaries}
 */
proto.dowtex.tournaments.TournamentSummaries.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dowtex.tournaments.TournamentSummary;
      reader.readMessage(value,proto.dowtex.tournaments.TournamentSummary.deserializeBinaryFromReader);
      msg.addTournaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.TournamentSummaries.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.TournamentSummaries.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.TournamentSummaries} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.TournamentSummaries.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.dowtex.tournaments.TournamentSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TournamentSummary tournaments = 1;
 * @return {!Array<!proto.dowtex.tournaments.TournamentSummary>}
 */
proto.dowtex.tournaments.TournamentSummaries.prototype.getTournamentsList = function() {
  return /** @type{!Array<!proto.dowtex.tournaments.TournamentSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dowtex.tournaments.TournamentSummary, 1));
};


/**
 * @param {!Array<!proto.dowtex.tournaments.TournamentSummary>} value
 * @return {!proto.dowtex.tournaments.TournamentSummaries} returns this
*/
proto.dowtex.tournaments.TournamentSummaries.prototype.setTournamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dowtex.tournaments.TournamentSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.TournamentSummary}
 */
proto.dowtex.tournaments.TournamentSummaries.prototype.addTournaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dowtex.tournaments.TournamentSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.TournamentSummaries} returns this
 */
proto.dowtex.tournaments.TournamentSummaries.prototype.clearTournamentsList = function() {
  return this.setTournamentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.TournamentSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.TournamentSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.TournamentSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
discipline: jspb.Message.getFieldWithDefault(msg, 3, ""),
app: jspb.Message.getFieldWithDefault(msg, 4, ""),
contextId: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
version: jspb.Message.getFieldWithDefault(msg, 7, 0),
visibility: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.TournamentSummary}
 */
proto.dowtex.tournaments.TournamentSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.TournamentSummary;
  return proto.dowtex.tournaments.TournamentSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.TournamentSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.TournamentSummary}
 */
proto.dowtex.tournaments.TournamentSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscipline(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContextId(value);
      break;
    case 6:
      var value = /** @type {!proto.dowtex.tournaments.TournamentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 8:
      var value = /** @type {!proto.dowtex.tournaments.Visibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.TournamentSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.TournamentSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.TournamentSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDiscipline();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContextId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string discipline = 3;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getDiscipline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setDiscipline = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string app = 4;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 context_id = 5;
 * @return {number}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getContextId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setContextId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional TournamentStatus status = 6;
 * @return {!proto.dowtex.tournaments.TournamentStatus}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getStatus = function() {
  return /** @type {!proto.dowtex.tournaments.TournamentStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.dowtex.tournaments.TournamentStatus} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 version = 7;
 * @return {number}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional Visibility visibility = 8;
 * @return {!proto.dowtex.tournaments.Visibility}
 */
proto.dowtex.tournaments.TournamentSummary.prototype.getVisibility = function() {
  return /** @type {!proto.dowtex.tournaments.Visibility} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.dowtex.tournaments.Visibility} value
 * @return {!proto.dowtex.tournaments.TournamentSummary} returns this
 */
proto.dowtex.tournaments.TournamentSummary.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dowtex.tournaments.TournamentView.repeatedFields_ = [10,11,12,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.TournamentView.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.TournamentView.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.TournamentView} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.TournamentView.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
discipline: jspb.Message.getFieldWithDefault(msg, 3, ""),
app: jspb.Message.getFieldWithDefault(msg, 4, ""),
contextId: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
version: jspb.Message.getFieldWithDefault(msg, 7, 0),
settingsJson: jspb.Message.getFieldWithDefault(msg, 8, ""),
visibility: jspb.Message.getFieldWithDefault(msg, 9, 0),
entrantsList: jspb.Message.toObjectList(msg.getEntrantsList(),
    proto.dowtex.tournaments.Entrant.toObject, includeInstance),
stagesList: jspb.Message.toObjectList(msg.getStagesList(),
    proto.dowtex.tournaments.Stage.toObject, includeInstance),
matchesList: jspb.Message.toObjectList(msg.getMatchesList(),
    proto.dowtex.tournaments.Match.toObject, includeInstance),
me: (f = msg.getMe()) && proto.dowtex.tournaments.Permissions.toObject(includeInstance, f),
shareToken: jspb.Message.getFieldWithDefault(msg, 14, ""),
standingsList: jspb.Message.toObjectList(msg.getStandingsList(),
    proto.dowtex.tournaments.Standing.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.TournamentView}
 */
proto.dowtex.tournaments.TournamentView.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.TournamentView;
  return proto.dowtex.tournaments.TournamentView.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.TournamentView} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.TournamentView}
 */
proto.dowtex.tournaments.TournamentView.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscipline(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContextId(value);
      break;
    case 6:
      var value = /** @type {!proto.dowtex.tournaments.TournamentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettingsJson(value);
      break;
    case 9:
      var value = /** @type {!proto.dowtex.tournaments.Visibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 10:
      var value = new proto.dowtex.tournaments.Entrant;
      reader.readMessage(value,proto.dowtex.tournaments.Entrant.deserializeBinaryFromReader);
      msg.addEntrants(value);
      break;
    case 11:
      var value = new proto.dowtex.tournaments.Stage;
      reader.readMessage(value,proto.dowtex.tournaments.Stage.deserializeBinaryFromReader);
      msg.addStages(value);
      break;
    case 12:
      var value = new proto.dowtex.tournaments.Match;
      reader.readMessage(value,proto.dowtex.tournaments.Match.deserializeBinaryFromReader);
      msg.addMatches(value);
      break;
    case 13:
      var value = new proto.dowtex.tournaments.Permissions;
      reader.readMessage(value,proto.dowtex.tournaments.Permissions.deserializeBinaryFromReader);
      msg.setMe(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareToken(value);
      break;
    case 15:
      var value = new proto.dowtex.tournaments.Standing;
      reader.readMessage(value,proto.dowtex.tournaments.Standing.deserializeBinaryFromReader);
      msg.addStandings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.TournamentView.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.TournamentView.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.TournamentView} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.TournamentView.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDiscipline();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContextId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getSettingsJson();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getEntrantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.dowtex.tournaments.Entrant.serializeBinaryToWriter
    );
  }
  f = message.getStagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.dowtex.tournaments.Stage.serializeBinaryToWriter
    );
  }
  f = message.getMatchesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.dowtex.tournaments.Match.serializeBinaryToWriter
    );
  }
  f = message.getMe();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.dowtex.tournaments.Permissions.serializeBinaryToWriter
    );
  }
  f = message.getShareToken();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStandingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.dowtex.tournaments.Standing.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.dowtex.tournaments.TournamentView.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentView.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string discipline = 3;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentView.prototype.getDiscipline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setDiscipline = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string app = 4;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentView.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 context_id = 5;
 * @return {number}
 */
proto.dowtex.tournaments.TournamentView.prototype.getContextId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setContextId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional TournamentStatus status = 6;
 * @return {!proto.dowtex.tournaments.TournamentStatus}
 */
proto.dowtex.tournaments.TournamentView.prototype.getStatus = function() {
  return /** @type {!proto.dowtex.tournaments.TournamentStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.dowtex.tournaments.TournamentStatus} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 version = 7;
 * @return {number}
 */
proto.dowtex.tournaments.TournamentView.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string settings_json = 8;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentView.prototype.getSettingsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setSettingsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Visibility visibility = 9;
 * @return {!proto.dowtex.tournaments.Visibility}
 */
proto.dowtex.tournaments.TournamentView.prototype.getVisibility = function() {
  return /** @type {!proto.dowtex.tournaments.Visibility} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.dowtex.tournaments.Visibility} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * repeated Entrant entrants = 10;
 * @return {!Array<!proto.dowtex.tournaments.Entrant>}
 */
proto.dowtex.tournaments.TournamentView.prototype.getEntrantsList = function() {
  return /** @type{!Array<!proto.dowtex.tournaments.Entrant>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dowtex.tournaments.Entrant, 10));
};


/**
 * @param {!Array<!proto.dowtex.tournaments.Entrant>} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
*/
proto.dowtex.tournaments.TournamentView.prototype.setEntrantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.dowtex.tournaments.Entrant=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.Entrant}
 */
proto.dowtex.tournaments.TournamentView.prototype.addEntrants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.dowtex.tournaments.Entrant, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.clearEntrantsList = function() {
  return this.setEntrantsList([]);
};


/**
 * repeated Stage stages = 11;
 * @return {!Array<!proto.dowtex.tournaments.Stage>}
 */
proto.dowtex.tournaments.TournamentView.prototype.getStagesList = function() {
  return /** @type{!Array<!proto.dowtex.tournaments.Stage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dowtex.tournaments.Stage, 11));
};


/**
 * @param {!Array<!proto.dowtex.tournaments.Stage>} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
*/
proto.dowtex.tournaments.TournamentView.prototype.setStagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.dowtex.tournaments.Stage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.Stage}
 */
proto.dowtex.tournaments.TournamentView.prototype.addStages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.dowtex.tournaments.Stage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.clearStagesList = function() {
  return this.setStagesList([]);
};


/**
 * repeated Match matches = 12;
 * @return {!Array<!proto.dowtex.tournaments.Match>}
 */
proto.dowtex.tournaments.TournamentView.prototype.getMatchesList = function() {
  return /** @type{!Array<!proto.dowtex.tournaments.Match>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dowtex.tournaments.Match, 12));
};


/**
 * @param {!Array<!proto.dowtex.tournaments.Match>} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
*/
proto.dowtex.tournaments.TournamentView.prototype.setMatchesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.dowtex.tournaments.Match=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.Match}
 */
proto.dowtex.tournaments.TournamentView.prototype.addMatches = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.dowtex.tournaments.Match, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.clearMatchesList = function() {
  return this.setMatchesList([]);
};


/**
 * optional Permissions me = 13;
 * @return {?proto.dowtex.tournaments.Permissions}
 */
proto.dowtex.tournaments.TournamentView.prototype.getMe = function() {
  return /** @type{?proto.dowtex.tournaments.Permissions} */ (
    jspb.Message.getWrapperField(this, proto.dowtex.tournaments.Permissions, 13));
};


/**
 * @param {?proto.dowtex.tournaments.Permissions|undefined} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
*/
proto.dowtex.tournaments.TournamentView.prototype.setMe = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.clearMe = function() {
  return this.setMe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dowtex.tournaments.TournamentView.prototype.hasMe = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string share_token = 14;
 * @return {string}
 */
proto.dowtex.tournaments.TournamentView.prototype.getShareToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.setShareToken = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * repeated Standing standings = 15;
 * @return {!Array<!proto.dowtex.tournaments.Standing>}
 */
proto.dowtex.tournaments.TournamentView.prototype.getStandingsList = function() {
  return /** @type{!Array<!proto.dowtex.tournaments.Standing>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dowtex.tournaments.Standing, 15));
};


/**
 * @param {!Array<!proto.dowtex.tournaments.Standing>} value
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
*/
proto.dowtex.tournaments.TournamentView.prototype.setStandingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.dowtex.tournaments.Standing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.Standing}
 */
proto.dowtex.tournaments.TournamentView.prototype.addStandings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.dowtex.tournaments.Standing, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.TournamentView} returns this
 */
proto.dowtex.tournaments.TournamentView.prototype.clearStandingsList = function() {
  return this.setStandingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.Entrant.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.Entrant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.Entrant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Entrant.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
seed: jspb.Message.getFieldWithDefault(msg, 3, 0),
withdrawn: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.Entrant}
 */
proto.dowtex.tournaments.Entrant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.Entrant;
  return proto.dowtex.tournaments.Entrant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.Entrant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.Entrant}
 */
proto.dowtex.tournaments.Entrant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeed(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithdrawn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.Entrant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.Entrant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.Entrant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Entrant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSeed();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getWithdrawn();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.dowtex.tournaments.Entrant.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Entrant} returns this
 */
proto.dowtex.tournaments.Entrant.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.dowtex.tournaments.Entrant.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.Entrant} returns this
 */
proto.dowtex.tournaments.Entrant.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 seed = 3;
 * @return {number}
 */
proto.dowtex.tournaments.Entrant.prototype.getSeed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Entrant} returns this
 */
proto.dowtex.tournaments.Entrant.prototype.setSeed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool withdrawn = 4;
 * @return {boolean}
 */
proto.dowtex.tournaments.Entrant.prototype.getWithdrawn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.Entrant} returns this
 */
proto.dowtex.tournaments.Entrant.prototype.setWithdrawn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.Stage.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.Stage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.Stage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Stage.toObject = function(includeInstance, msg) {
  var f, obj = {
ordinal: jspb.Message.getFieldWithDefault(msg, 1, 0),
format: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.Stage}
 */
proto.dowtex.tournaments.Stage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.Stage;
  return proto.dowtex.tournaments.Stage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.Stage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.Stage}
 */
proto.dowtex.tournaments.Stage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdinal(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormat(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.Stage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.Stage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.Stage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Stage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdinal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFormat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 ordinal = 1;
 * @return {number}
 */
proto.dowtex.tournaments.Stage.prototype.getOrdinal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Stage} returns this
 */
proto.dowtex.tournaments.Stage.prototype.setOrdinal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string format = 2;
 * @return {string}
 */
proto.dowtex.tournaments.Stage.prototype.getFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dowtex.tournaments.Stage} returns this
 */
proto.dowtex.tournaments.Stage.prototype.setFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 status = 3;
 * @return {number}
 */
proto.dowtex.tournaments.Stage.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Stage} returns this
 */
proto.dowtex.tournaments.Stage.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.Standing.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.Standing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.Standing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Standing.toObject = function(includeInstance, msg) {
  var f, obj = {
stageOrdinal: jspb.Message.getFieldWithDefault(msg, 1, 0),
entrantId: jspb.Message.getFieldWithDefault(msg, 2, 0),
played: jspb.Message.getFieldWithDefault(msg, 3, 0),
wins: jspb.Message.getFieldWithDefault(msg, 4, 0),
draws: jspb.Message.getFieldWithDefault(msg, 5, 0),
losses: jspb.Message.getFieldWithDefault(msg, 6, 0),
points: jspb.Message.getFieldWithDefault(msg, 7, 0),
scoreDifference: jspb.Message.getFieldWithDefault(msg, 8, 0),
scoresFor: jspb.Message.getFieldWithDefault(msg, 9, 0),
rank: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.Standing}
 */
proto.dowtex.tournaments.Standing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.Standing;
  return proto.dowtex.tournaments.Standing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.Standing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.Standing}
 */
proto.dowtex.tournaments.Standing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStageOrdinal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEntrantId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlayed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWins(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDraws(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLosses(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPoints(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScoreDifference(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScoresFor(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.Standing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.Standing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.Standing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Standing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStageOrdinal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEntrantId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPlayed();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getWins();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDraws();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLosses();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPoints();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getScoreDifference();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getScoresFor();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional int32 stage_ordinal = 1;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getStageOrdinal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setStageOrdinal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 entrant_id = 2;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getEntrantId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setEntrantId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 played = 3;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getPlayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setPlayed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 wins = 4;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getWins = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setWins = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 draws = 5;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getDraws = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setDraws = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 losses = 6;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getLosses = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setLosses = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 points = 7;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 score_difference = 8;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getScoreDifference = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setScoreDifference = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 scores_for = 9;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getScoresFor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setScoresFor = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 rank = 10;
 * @return {number}
 */
proto.dowtex.tournaments.Standing.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Standing} returns this
 */
proto.dowtex.tournaments.Standing.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.Match.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.Match.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.Match} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Match.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
stageOrdinal: jspb.Message.getFieldWithDefault(msg, 2, 0),
round: jspb.Message.getFieldWithDefault(msg, 3, 0),
position: jspb.Message.getFieldWithDefault(msg, 4, 0),
side: jspb.Message.getFieldWithDefault(msg, 5, 0),
entrantA: jspb.Message.getFieldWithDefault(msg, 6, 0),
entrantB: jspb.Message.getFieldWithDefault(msg, 7, 0),
winnerId: jspb.Message.getFieldWithDefault(msg, 8, 0),
status: jspb.Message.getFieldWithDefault(msg, 9, 0),
scoreA: jspb.Message.getFieldWithDefault(msg, 10, 0),
scoreB: jspb.Message.getFieldWithDefault(msg, 11, 0),
hasScore: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.Match}
 */
proto.dowtex.tournaments.Match.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.Match;
  return proto.dowtex.tournaments.Match.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.Match} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.Match}
 */
proto.dowtex.tournaments.Match.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStageOrdinal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRound(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSide(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEntrantA(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEntrantB(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWinnerId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScoreA(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScoreB(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.Match.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.Match.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.Match} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Match.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStageOrdinal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRound();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSide();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getEntrantA();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getEntrantB();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getWinnerId();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getScoreA();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getScoreB();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getHasScore();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 stage_ordinal = 2;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getStageOrdinal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setStageOrdinal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 round = 3;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getRound = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setRound = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 position = 4;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 side = 5;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getSide = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setSide = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 entrant_a = 6;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getEntrantA = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setEntrantA = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 entrant_b = 7;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getEntrantB = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setEntrantB = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 winner_id = 8;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getWinnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setWinnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 status = 9;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 score_a = 10;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getScoreA = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setScoreA = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 score_b = 11;
 * @return {number}
 */
proto.dowtex.tournaments.Match.prototype.getScoreB = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setScoreB = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool has_score = 12;
 * @return {boolean}
 */
proto.dowtex.tournaments.Match.prototype.getHasScore = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.Match} returns this
 */
proto.dowtex.tournaments.Match.prototype.setHasScore = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dowtex.tournaments.Permissions.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dowtex.tournaments.Permissions.prototype.toObject = function(opt_includeInstance) {
  return proto.dowtex.tournaments.Permissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dowtex.tournaments.Permissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Permissions.toObject = function(includeInstance, msg) {
  var f, obj = {
canView: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
canOrganize: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
reportMatchIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dowtex.tournaments.Permissions}
 */
proto.dowtex.tournaments.Permissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dowtex.tournaments.Permissions;
  return proto.dowtex.tournaments.Permissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dowtex.tournaments.Permissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dowtex.tournaments.Permissions}
 */
proto.dowtex.tournaments.Permissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanView(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanOrganize(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addReportMatchIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dowtex.tournaments.Permissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dowtex.tournaments.Permissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dowtex.tournaments.Permissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dowtex.tournaments.Permissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanView();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCanOrganize();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getReportMatchIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional bool can_view = 1;
 * @return {boolean}
 */
proto.dowtex.tournaments.Permissions.prototype.getCanView = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.Permissions} returns this
 */
proto.dowtex.tournaments.Permissions.prototype.setCanView = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool can_organize = 2;
 * @return {boolean}
 */
proto.dowtex.tournaments.Permissions.prototype.getCanOrganize = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dowtex.tournaments.Permissions} returns this
 */
proto.dowtex.tournaments.Permissions.prototype.setCanOrganize = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated int64 report_match_ids = 3;
 * @return {!Array<number>}
 */
proto.dowtex.tournaments.Permissions.prototype.getReportMatchIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.dowtex.tournaments.Permissions} returns this
 */
proto.dowtex.tournaments.Permissions.prototype.setReportMatchIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.dowtex.tournaments.Permissions} returns this
 */
proto.dowtex.tournaments.Permissions.prototype.addReportMatchIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dowtex.tournaments.Permissions} returns this
 */
proto.dowtex.tournaments.Permissions.prototype.clearReportMatchIdsList = function() {
  return this.setReportMatchIdsList([]);
};


/**
 * @enum {number}
 */
proto.dowtex.tournaments.Visibility = {
  PUBLIC: 0,
  FRIENDS: 1,
  PASSWORD: 2,
  PRIVATE: 3
};

/**
 * @enum {number}
 */
proto.dowtex.tournaments.TournamentStatus = {
  DRAFT: 0,
  RUNNING: 1,
  COMPLETED: 2,
  CANCELLED: 3
};

/**
 * @enum {number}
 */
proto.dowtex.tournaments.MatchStatus = {
  PENDING: 0,
  READY: 1,
  LIVE: 2,
  DONE: 3,
  BYE: 4
};

goog.object.extend(exports, proto.dowtex.tournaments);
